module.exports = require("material-table");